export default __webpack_public_path__ + "static/media/toothface-new.3f0834b3.jpg";